import React from "react";

export const Increase = (props) => {
  return (
    <div id="increase">
      <div className="container">
        <div className="col-md-12 text-center">
          <img src="img/title-increase.png" className="img-title" alt="" />
        </div>
        <div className="row text-center">
          <div className="col-md-12">
            <div className="increase">
              <a href="https://liff.line.me/1645278921-kWRPP32q/?accountId=bwd88">
                <img src="img/increase-icon.png" className="img-increase" alt="" />
                </a>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};
